import api from "../../api";

class ClientPrice {
  index() {
   return api.get('group/enterprise');
  }
}

export default new ClientPrice();
